import React from "react";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
class LichSuVayThemTraBotGocView extends React.Component {
  constructor(props) {
    super(props);
    let isShow = true;
    let displayText = "contents";
    if (matchMedia) {
      var mq = window.matchMedia("(max-width: 768px)");
      isShow = !mq.matches;
      if (mq.matches) displayText = "block";
    }
    this.state = {
      text1: "",
      itemShow: {
        item: null,
        isShow: isShow,
        displayText,
      },
    };
  }
  showRow = (item) => () => {
    let { itemShow } = this.state;
    let isShow = true;
    if (matchMedia) {
      var mq = window.matchMedia("(max-width: 768px)");
      isShow = mq.matches && !itemShow.isShow;
    }
    itemShow.item = item;
    itemShow.isShow = isShow;
    this.setState({ itemShow });
  };
  getGhiChu(item) {
    let { Value, Note } = item;
    let loai = Value > 0 ? "Trả bớt gốc" : "Vay thêm";
    // API nối thêm hậu tố " .Vay thêm" / " .Trả bớt gốc" vào Note của bảng ThuChi,
    // bỏ hậu tố ra để biết ghi chú người dùng nhập có dữ liệu hay không
    let noteGoc = (Note || "").replace(/\.?\s*(Vay thêm|Trả bớt gốc)\s*$/i, "").trim();
    return noteGoc ? (Note || "").trim() : loai;
  }
  renderRow(List) {
    return List.map((item, index) => {
      let { Time, Value, IsConfigVayThem } = item;
      return (
        <tr className="">
          <td>{index + 1}</td>
          <td className="">{getDate(Time)}</td>
          <td className="text-right">{formatNumber(Value)}</td>
          <td className="text-right">{`${Value > 0 ? '' : +IsConfigVayThem}`}</td>
          <td className="text-left">
            {" "}
            {this.getGhiChu(item)}{" "}
          </td>
        </tr>
      );
    });
  }
  render() {
    let { TongTien, List ,TotalRows} = this.props;
    return (
      <div className="table-from-detailtl1">
        <div className="Left808x200  Table-main-morman table-noboder-new">
          <div className="table-responsive table-new1">
            <table className="table table-bordered table-hover table-rounded" style={{marginTop:"20px"}}>
              <thead>
                <tr>
                  <th className="w-stt"><span className=" color-do-bold">[{TotalRows}] </span><br/>&nbsp;</th>
                  <th className="w-10">Ngày vay<br/>&nbsp;</th>
                  <th className="text-right w-20"> Số tiền
                    <br /> <i className="la la-dollar color-do-bold"></i>
                    <span className="color-do-bold">={" "}{formatNumber(TongTien)}</span>
                  </th>
                  <th className="text-right w-20">Lãi ngày vay thêm<br/>&nbsp;</th>
                  <th className="text-left">Ghi chú<br/>&nbsp;</th>
                </tr>
              </thead>
              <tbody>{this.renderRow(List)}</tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}
export default LichSuVayThemTraBotGocView;
